import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { ProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsState";
import { VariantChildrenGridApiParameter } from "@thkStore/Types/VariantChildrenGridModel";

export function getVariantChildrenGridDataView(
    state: ApplicationState,
    parameter: VariantChildrenGridApiParameter,
) {
    return getDataView<any, ProductsDataView>(state.data.products, parameter);
}
